import {useSelector} from 'react-redux';
import {userRolesConstants} from '../../constants';

/**
 * Whether this user may start an Open Banking connect session.
 *
 * Mirrors the server rule rather than approximating it: app-openbanking gates
 * `POST /connections` to ADMIN and MANAGER, so anyone else clicking "Connect bank" is refused at
 * the API Gateway authorizer before the service ever sees the request (H1MVP-4793).
 *
 * ⚠ Deliberately NOT `useIsAdminOrManager`. That reads `state.user.isAdmin`, which is derived from
 * `teamsHelpers.isAdmin` — and that helper returns true for BOOKKEEPER and SUPPORT as well as
 * ADMIN. Using it here would keep offering the action to the exact roles the server refuses, which
 * is the bug this is meant to close. Roles are compared to `userRolesConstants` directly.
 *
 * Also the right product answer: the SaltEdge customer is the requesting user's email and consent
 * expiry mail goes there, so the client's own Admin should be connecting the bank, not a WithLess
 * rep acting as SUPPORT.
 *
 * @returns {boolean} True only for ADMIN and MANAGER.
 */
export const useCanConnectBank = () => {
  const role = useSelector((state) => state.user?.employee?.role);
  return role === userRolesConstants.ADMIN || role === userRolesConstants.MANAGER;
};
